import { TYPE_KEY } from "../common/constant";

const MAINTENANCE_STATUS_RECEIVED = "MAINTENANCE_STATUS_RECEIVED";

export const MAINTENANCE_ENABLED = "enabled";
export const MAINTENANCE_CHECKED = "checked";
export const MAINTENANCE_MESSAGE_DE = "messageDe";
export const MAINTENANCE_MESSAGE_EN = "messageEn";

const initialState = {
  [MAINTENANCE_ENABLED]: false,
  [MAINTENANCE_CHECKED]: false,
  [MAINTENANCE_MESSAGE_DE]: "",
  [MAINTENANCE_MESSAGE_EN]: ""
};

export default function reducer(state = initialState, action) {
  switch (action[TYPE_KEY]) {
    case MAINTENANCE_STATUS_RECEIVED:
      return {
        ...state,
        [MAINTENANCE_ENABLED]: action[MAINTENANCE_ENABLED],
        [MAINTENANCE_CHECKED]: true,
        [MAINTENANCE_MESSAGE_DE]: action[MAINTENANCE_MESSAGE_DE],
        [MAINTENANCE_MESSAGE_EN]: action[MAINTENANCE_MESSAGE_EN]
      };

    default:
      return state;
  }
}

export function loadMaintenanceStatus() {
  return (dispatch) => {
    fetch("/maintenance.json", { cache: "no-store" })
      .then((response) => (response.ok ? response.json() : {}))
      .then((maintenanceStatus) => dispatch(maintenanceStatusReceived(maintenanceStatus)))
      .catch(() => dispatch(maintenanceStatusReceived({})));
  };
}

function maintenanceStatusReceived(maintenanceStatus) {
  const enabled = maintenanceStatus.enabled === true || maintenanceStatus.enabled === "true";

  return {
    [TYPE_KEY]: MAINTENANCE_STATUS_RECEIVED,
    [MAINTENANCE_ENABLED]: enabled,
    [MAINTENANCE_MESSAGE_DE]: maintenanceStatus.messageDe || "",
    [MAINTENANCE_MESSAGE_EN]: maintenanceStatus.messageEn || ""
  };
}
